<template>
  <div class="mb-2">
    <table class="table b-table table-striped">
      <thead>
        <tr>
          <th colspan="2" class="text-center">
            {{ $t("operational_security.operational_processes.maintenance_devices") }}
          </th>
        </tr>
        <tr>
          <th>{{ $t("operational_security.operational_processes.name") }}</th>
          <th>{{ $t("operational_security.operational_processes.type") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="device in devices">
          <td>
            <span>{{ device.name }}</span>
          </td>
          <td>
            <span>{{ device.type }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    device_proxies: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    devices() {
      return this.device_proxies.map((item) => {
        return item.cameras_proxy?.camera;
      });
    },
  },
};
</script>

